import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import walletIcon from "~/assets/wallet.png";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";
import { Button } from "~/components/ui/button";
import { UsageLimitModal } from "~/features/billing/UsageLimitModal";

interface PaymentFailedModalProps {
  open: boolean;
  organizationId: string;
}

export const PaymentFailedModal = ({
  open,
  organizationId,
}: PaymentFailedModalProps) => {
  const { formatMessage } = useIntl();
  const [isUsageLimitModalOpen, setIsUsageLimitModalOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsUsageLimitModalOpen(false);
    }
  }, [open]);

  const handlePaymentClick = () => {
    setIsUsageLimitModalOpen(true);
  };

  return (
    <>
      <AlertDialog open={open && !isUsageLimitModalOpen}>
        <AlertDialogContent className="w-[608px] justify-center px-6 py-10">
          <AlertDialogHeader className="flex flex-col items-center">
            <img src={walletIcon} alt="Wallet" className="h-14 w-14 mt-4" />
            <AlertDialogTitle className="text-lg font-semibold text-base-foreground">
              {formatMessage({
                id: "paymentFailed.title",
                defaultMessage: "Subscription Paused",
              })}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-muted-foreground text-sm text-center">
              {formatMessage({
                id: "paymentFailed.description",
                defaultMessage:
                  "There's a problem with your payment method, and your subscription is on hold due to a balance due.",
              })}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter className="flex flex-col justify-center sm:justify-center">
            <Button onClick={handlePaymentClick}>
              {formatMessage({
                id: "paymentFailed.update",
                defaultMessage: "Update Billing",
              })}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {isUsageLimitModalOpen && (
        <UsageLimitModal organizationId={organizationId} />
      )}
    </>
  );
};
